<template>
	
  <div id="app" >
    <router-view/>
  </div>
</template>

<style lang="less">
	html,body{
		width: 100%;
		height: 100%;
		margin: 0;
		padding: 0;
		font-size: 16px;
		min-width: 78.125rem;
	}
	
</style>
<script>
	export default{
	
	}
</script>
